/* eslint import/prefer-default-export: 0 */

export const psychological = {
  pvq: {
    heading: {
      intro: '',
      competence:
      'Has a court or administrative agency ever issued an order declaring you mentally incompetent?',
      consultationIntro: `The U.S. government recognizes the importance of the psychological and emotional health of its
       workforce and advocates proactive involvement with mental health and related services to support wellbeing and 
       recovery of federal employees and others`,
      consultation:
      'In the past five years, has a court or administrative agency ordered you to consult with a mental health professional (for example, a psychiatrist, psychologist, licensed clinical social worker, etc.)?',
      consultation2:
      '(An order to a military member by a superior officer is not within the scope of this question, and therefore would not require an affirmative response. An order by a military court would be within the scope of the question and would require an affirmative response.)',
      hospitalization: 'In the past five years, have you been admitted to a hospital, or been required to be evaluated in a hospital for any mental health condition or behavioral emergency? Include any inpatient hospitalizations, partial hospitalizations, and emergency room visits for a mental health condition(s) or behavioral emergency.',
      diagnoses:
      'The following question asks whether you have been diagnosed with a specified mental health condition that may, particularly if untreated, impact your judgment, reliability, or trustworthiness. If you answer in the affirmative, we will seek additional information about the seriousness and symptoms of the condition, as well as any applicable course of treatment.\n\nIt is important to note that any such diagnosis, in and of itself, **is not a reason** to revoke or deny eligibility/or access to classified information or for holding a sensitive position, suitability or fitness to obtain or retain Federal or contract employment, or eligibility for physical or logical access to federally controlled facilities or information systems.',
    },
    section: {
      name: 'Psychological and emotional health',
    },
    subsection: {
      intro: 'Introduction',
      competence: 'Competence',
      consultations: 'Consultations',
      hospitalizations: 'Hospitalizations',
      diagnoses: 'Diagnoses',
      conditions: 'Existing conditions',
      review: 'Review',
    },
    destination: {
      intro: 'Psychological and emotional health intro',
      psychological: 'Psychological and emotional health',
      competence: 'Competence',
      consultation: 'Consultations',
      consultations: 'Consultations',
      hospitalization: 'Hospitalizations',
      hospitalizations: 'Hospitalizations',
      diagnoses: 'Diagnoses',
      conditions: 'Existing conditions',
      existingConditions: 'Existing conditions',
      review: 'Review',
    },
    default: {
      label: {
        toDate: 'N/A',
        fromDate: 'N/A',
      },
    },
    appealsComments: 'Optional Comments',
    intro: {
      title: 'Psychological and Emotional Health',
      para1:
      `The U.S. government recognizes the importance of the psychological and emotional health of its workforce and 
advocates proactive involvement with mental health and related services to support wellbeing and recovery of federal 
employees and others. Your truthful responses and any information derived from your responses will not be used as 
evidence against you in a criminal proceeding.`,
      para2:
      'The following questions ask about behavioral and mental health experiences.',
      para3:
      `Mental health treatment and counseling, in and of itself, is not a reason to revoke or deny eligibility for access to 
classified information or for holding a sensitive position, suitability for fitness to obtain or retain Federal or contract 
employment, or eligibility for physical or logical access to federally controlled facilities or information systems. Seeking, 
undergoing, or continuing behavioral or mental health care is typically associated with good judgment.`,
    },
    tour: {
      para: 'Take a guided tour through the section',
    },
    review: {
      para: 'View all the sections associated with psychological and emotional health at once',
    },
    competence: {
      heading: {
        occurred: 'When did this court or administrative agency declare you mentally incompetent?',
        courtName:
        'What is the name of the court or administrative agency declaring you mentally incompetent?',
        courtAddress: 'Is this court or administrative agency in the U.S.?',

        disposition: 'What was the final disposition? (That is, did the order declaring you mentally incompetent stand or did you successfully overturn it?)',
        appealCourtName: 'What is the name of the court or administrative agency you appealed to?',

        appealed: 'Did you appeal this decision to a higher court or administrative agency?',
        appealedAnother:
        'Is there another appeal to report?',
        needMore: 'Since you answered yes, we need more information',
      },
      label: {
        appealCourtAddress: 'Is this appeal\'s court or administrative agency in the U.S.?',
        courtAddress: 'Is this court or administrative agency in the U.S.?',
        courtAddressDomesticTitle: 'What is the address?',
        courtAddressForeignTitle: 'Where is this court located?',
        disposition: 'Provide the final disposition',
      },
      help: {
        occurred: {
          title: 'Estimate the date if unsure',
          message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        courtName: {
          title: 'Need help with this court or agency name?',
          message: 'Tell us the name of the court or administrative agency that issued the order.',
          note: '',
        },
        courtAddress: {
          title: 'Try looking up the court or agency name, this could help you find the address',
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        incompetent: {
          title: 'Need help with this question?',
          message:
          'Has a court or administrative agency EVER ordered you to consult with a mental health professional?',
        },
        disposition: {
          title: "Tell us the ruling regarding the court or agency's decision",
          message:
          "If you can't remember your disposition a family member or the court/agency may be able to help you.",
          note: '',
        },
      },
      collection: {
        summaryCourtName: 'Provide your order details below',
        description: 'Summary of orders',
        appendTitle:
        'Do you have another instance in which a court or administrative agency issued an order declaring you mentally incompetent to report?',
        appendLabel: 'Add another order',
        itemType: 'Order Item',
      },
      comments: 'Optional Comments',
      summaryComments: 'Optional Summary Comments',
    },
    consultation: {
      heading: {
        occurred: 'When did this court or administrative agency order you to consult with a mental health professional?',
        courtName:
      'What is the name of the court or administrative agency ordering you to consult with a mental health professional?',
        courtAddress: 'Provide the address of the court or administrative agency',
        disposition: 'What was the final disposition? (that is, did the order to consult with a mental health professional stand or did you successfully overturn it)',
        appealCourtName: 'Name of court or administrative agency',
        appealCourtAddress: 'Provide the address of the court or administrative agency',
        appealed: 'Did you appeal this decision to a higher court or administrative agency?',
        appealedAnother:
        'Is there another appeal to report?',
        needMore: 'Since you answered yes, we need more information',
      },
      label: {
        appealCourtAddress: 'Is this appeal\'s court or administrative agency in the U.S.?',
        courtAddress: 'Is this court or administrative agency in the U.S.?',
        courtAddressDomesticTitle: 'What is the address?',
        courtAddressForeignTitle: 'Where is this court located?',
        disposition: 'What was the final disposition?',
      },
      help: {
        occurred: {
          title: 'Estimate the date if unsure',
          message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        courtName: {
          title: 'Need help with this court or agency name?',
          message: 'Tell us the name of the court or administrative agency that issued the order.',
          note: '',
        },
        courtAddress: {
          title: 'Try looking up the court or agency name, this could help you find the address',
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        disposition: {
          title: "Tell us the ruling regarding the court or agency's decision",
          message:
          "If you can't remember your disposition a family member or the court/agency may be able to help you.",
          note: '',
        },
        appealed: {
          title: 'Need help with whether this matter was appealed?',
          message: 'Was this matter appealed to a higher court or administrative agency?',
          note: '',
        },
        incompetent: {
          title: 'Need help with this question?',
          message:
          'Has a court or administrative agency EVER ordered you to consult with a mental health professional',
        },
      },
      collection: {
        summaryCourtName: 'Provide your order details below',
        description: 'Summary of orders',
        appendTitle:
        'Do you have another instance in which a court or administrative agency issued an order to consult a mental health professional to report?',
        appendLabel: 'Add another order',
        itemType: 'Order Item',
      },
      comments: 'Optional Comments',
      summaryComments: 'Optional Summary Comments',
    },
    hospitalization: {
      heading: {
        admission: 'Was the hospitalization voluntary? (A "No" response will be considered as involuntary)',
        treatment: '',
        treatmentStart: 'When did you go to the hospital?',
        treatmentEnd: 'When did leave the hospital?',
        facility: 'What was the name of the hospital? ',
        address: 'Provide the address of the facility where treatment was provided',
      },
      label: {
        address: 'Is this hospital in the U.S.?',
        addressDomesticTitle: 'What is the address?',
        addressForeignTitle: 'What is the address?',
        voluntaryAdmission: 'Voluntary',
        involuntaryAdmission: 'Involuntary',
      },
      collection: {
        description: 'Summary of hospitalizations',
        summary: 'Provide your hospitalization details below',
        appendTitle:
        'Do you, in the last five years, have another occurrence of having been admitted to a hospital, or been required to be evaluated in a hospital for ANY mental health condition or behavioral emergency (include any inpatient hospitalizations, partial hospitalizations, and emergency room visitsfor a mental health condition(s) or behavioral emergency)?',
        appendLabel: 'Add another hospitalization',
        itemType: 'Hospitalization Item',
      },
      help: {
        incompetent: {
          title: 'Need help with mental health hospitalization?',
          message: 'Have you EVER been hospitalized for a mental health condition?',
          note: '',
        },
        treatment: {
          title: 'Estimate the date if unsure',
          message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        facility: {
          title: 'Need help with this facility name?',
          message: 'Tell us the name of the facility where you were hospitalized.',
          note: '',
        },
        address: {
          title: 'Try looking up the facility name, this could help you find the address',
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
      },
      comments: 'Optional Comments',
      itemComments: 'Optional Comments',
      summaryComments: 'Optional Summary Comments',
    },
    diagnosis: {
      heading: {
        condition: 'Identify the diagnosis or health condition',
        diagnosed: 'What are the dates of diagnosis?',
        healthcareProfessional: 'Health care professional info',
        effective: 'Was the counseling/treatment effective in managing your symptoms?',
        sameTreatmentFacility: 'Is the agency, organization, or facility where counseling/treatment was provided in the last five years same as above?',
        facility: 'Agency/organization/facility',
        explanation: 'Provide explanation',
      },
      label: {
        psychotic: 'Psychotic disorder',
        schizophrenia: 'Schizophrenia',
        schizoaffective: 'Schizoaffective disorder',
        delusional: 'Delusional disorder',
        bipolar: 'Bipolar mood disorder',
        borderline: 'Borderline personality disorder',
        antisocial: 'Antisocial personality disorder',
      },
      help: {
        condition: {
          title: 'Need help with health condition',
          message: 'Provide the name of the diagnosis or health condition',
          note: '',
        },
        diagnosed: {
          title: 'Estimate the date if unsure',
          message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note:
          'Note: If this is a current diagnosis or health condition enter the start date and click the "Present" button for the "To date".',
        },
        explanation: {
          title: "Tell us more about why the counseling/treatment wasn't effective?",
          message: "Let us know why this counseling/treatment didn't improve your symptoms.",
          note: 'Go into as much detail as you need to full explain.',
        },
      },
      comments: 'Optional Comments',
      person: {
        heading: {
          name: 'What is the name of the health care professional who diagnosed you, or is currently treating you for such a diagnosis, or with whom you have discussed such condition?',
        },
        label: {
          address: 'Is the address of the healthcare professional in the U.S.?',
          addressDomesticTitle: 'What is the address?',
          addressForeignTitle: 'What is the address?',
          name: 'Name',
          phone: 'What is the health care professional\'s telephone number?',
        },
        help: {
          address: {
            title: 'Try looking up their name, this could help you find the address',
            message: 'If you can only find a phone number try calling and asking for the address.',
            note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
          name: {
            title: 'Need help the name of the healthcare professional?',
            message: 'Tell us the full name of the healthcare professional.',
            note: 'Note: If you can’t remember this name a family member may be able to help you.',
          },
        },
        comments: 'Optional Comments',
      },
      facility: {
        heading: {
          name:
          'What is the agency, organization, or facility where counseling/treatment was provided in the last five years?',
          address:
          'Provide the address of any agency/organization/facility where counseling/treatment was provided',
          addressDomesticTitle: 'What is the address?',
          addressForeignTitle: 'What is the address?',
        },
        label: {
          name: 'Name',
          phone: 'What is the agency, organization, or facility\'s telephone number?',
          address: 'Is the address of the agency, organization, or facility where treatment was provided in the last five years in the U.S.?',
          addressDomesticTitle: 'What is the address?',
          addressForeignTitle: 'What is the address?',
        },
        help: {
          address: {
            title: 'Try looking up the name, this could help you find the address.',
            message: 'If you can only find a phone number try calling and asking for the address.',
            note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
          name: {
            title: 'Need help entering name of the facility where treatment was provided?',
            message: 'Tell us the full name of the facility.',
            note:
            'Note: If you can’t remember this facility name a family member may be able to help you.',
          },
        },
        comments: 'Optional Comments',
      },
    },
    diagnoses: {
      heading: {
        didNotConsult:
        'In the last seven years, have there been any occasions when you did not consult with a medical professional before altering or discontinuing, or failing to start a prescribed course of treatment for any of the listed diagnoses?',
        diagnoses:
        'Have you ever been diagnosed by a physician or other health professional (for example, a psychiatrist, psychologist, licensed clinical social worker, or nurse practitioner) with psychotic disorder, schizophrenia, schizoaffective disorder, delusional disorder, bipolar mood disorder, borderline personality disorder, or antisocial personality disorder?',
        examples: '',
        inTreatment: 'Are you currently in treatment?',
      },
      collection: {
        description: 'Summary of diagnoses',
        summary: 'Provide your diagnosis details below',
        appendTitle:
        'Do you have another instance of having been diagnosed by a physician or other health professional (for example, a psychiatrist, psychologist, licensed clinical social worker, or nurse practitioner) with psychotic disorder, schizophrenia, schizoaffective disorder, delusional disorder, bipolar mood disorder, borderline personality disorder, or antisocial personality disorder?',
        appendMessage:
        '',
        appendLabel: 'Add another diagnosis',
        itemType: 'Diagnosis Item',
      },
      professional: {
        heading: {
          name:
          'Provide the name and telephone number of the health care professional who diagnosed you, or is currently treating you for such diagnosis, or with whom you have discussed such condition',
          address:
          'Provide the address of the health care professional who diagnosed you, or is currently treating you for such diagnosis, or with whom you have discussed such condition',
        },
        label: {
          address: 'This address is',
          name: 'Name',
          phone: 'Telephone',
        },
        help: {
          name: {
            title: 'Need help the name of the healthcare professional?',
            message: 'Tell us the full name of the healthcare professional.',
            note: 'Note: If you can’t remember this name a family member may be able to help you.',
          },
          address: {
            title: 'Try looking up their name, this could help you find the address',
            message: 'If you can only find a phone number try calling and asking for the address.',
            note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
        },
        comments: 'Optional Comments',
      },
      treatment: {
        collection: {
          description: 'Summary of treatments',
          summary: 'Provide your treatment details below',
          appendTitle: 'Do you have an additional instance where you are currently in treatment?',
          appendLabel: 'Add another treatment',
          itemType: 'Treatment Item',
        },
      },
      inTreatmentSummaryComments: 'Optional Summary Comments',
      didNotConsultComments: 'Optional Comments',
      summaryComments: 'Optional Summary Comments',
      comments: 'Optional Comments',
      inTreatmentComments: 'Optional Comments',
      help: {
        diagnosed: {
          title: 'Help with diagnoses',
          message:
          'Have you EVER been diagnosed by a physician or other health professional (for example, a psychiatrist, psychologist, licensed clinical social worker, or nurse practitioner) with psychotic disorder, schizophrenia, schizoaffective disorder, delusional disorder, bipolar mood disorder, borderline personality disorder, or antisocial personality disorder?',
          note: '',
        },
        didNotConsult: {
          title: 'Help with occasions when not consulting',
          message:
          'In the last seven years, have there been any occasions when you did not consult with a medical professional before altering or discontinuing, or failing to start a prescribed course of treatment for any of the listed diagnoses?',
          note: '',
        },
        inTreatment: {
          title: 'Help with current treatment',
          message: 'Are you currently in treatment?',
          note: '',
        },
        condition: {
          title: 'Help with diagnosis',
          message: 'Identify the diagnosis or health condition',
          note: '',
        },
      },
      person: {
        help: {
          name: {
            title: 'Need help the name of the healthcare professional?',
            message: 'Tell us the full name of the healthcare professional.',
          },
          address: {
            title:
            "Try looking up the health care professional's name, this could help you find the address",
            message: 'If you can only find a phone number try calling and asking for the address.',
            note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
        },
      },
    },
    existingConditions: {
      heading: {
        intro: 'Have you ever believed you had any of the following?',
        psychosis: 'A. Psychotic symptoms or psychosis (i.e., hearing, seeing, feeling, or smelling things that were not real or could not be perceived by others; belief that other people are out to get you, that you are being followed, watched, or recorded; belief that you could read other people\'s minds or they can read yours; or belief that you have a special power).',
        manic: 'B. Manic or hypomanic episodes (i.e., sustained periods of very high energy, feeling hyper, euphoric, highly distractible, or having a decreased need for sleep or not sleeping for long periods of time without feeling tired).',
        impulsive: 'C. Impulsive behavior or behavior you felt unable to control and caused negative consequences (e.g., uncontrolled gambling, other addictive behavior, compulsive sexual behavior, etc.).',
        planToHurt: 'D. A plan to hurt or kill someone else that you either acted upon or would have acted upon if someone had not intervened.',

        hasCondition:
        'Do you have a mental health or other health condition that substantially adversely affects your judgment, reliability, or trustworthiness even if you are not experiencing such symptoms today?',
        receivedTreatment:
        'In the last five years, did you seek treatment due to any of these?',
        didNotFollow:
        'Have you ever chosen not to follow a prescribed course of treatment for any of these conditions?',
        explanation: 'Provide explanation',
        didNotFollowExplanation: 'Provide explanation',
      },
      para: {
        hasCondition:
        'Note: If your judgment, reliability, or trustworthiness is not substantially adversely affected by a mental health or other condition, then you should answer **"no"** even if you have a mental health or other condition requiring treatment.\n\nFor example, if you are in need of emotional or mental health counseling as a result of service as a first responder, service in a military combat environment, having been sexually assaulted or a victim of domestic violence, or marital issues, but your judgment, reliability or trustworthiness is not substantially adversely affected, then answer **"no."**',
        receivedTreatment:
        'You may choose not to answer this question. However, such consultation or treatment will not disqualify you and is considered to be a positive action.',
      },
      help: {
        receivedTreatment: {
          title: 'Help with counseling or treatment',
          message:
          'Did you ever receive or are you currently receiving counseling or treatment for that condition?',
          note: '',
        },
      },
      receivedTreatment: {
        label: {
          yes: 'Yes',
          no: 'No',
          decline: 'I decline to answer',
        },
      },
      treatment: {
        collection: {
          description: 'Summary of treatments',
          summary: 'Provide your treatment details below',
          appendTitle1:
          'Do you have any additional episodes described in A, B, C, or D to report?',
          appendTitle: [
            'Do you have any additional instances to report of treatment for: ',
            '- Psychotic symptoms or psychosis (i.e., hearing, seeing, feeling, or smelling things that were not real or could not be perceived by others; belief that other people are out to get you, that you are being followed, watched, or recorded; belief that you could read other people\'s minds or they can read yours; or belief that you have a special power);',
            '- Manic or hypomanic episodes (i.e., sustained periods of very high energy, feeling hyper, euphoric, highly distractible, or having a decreased need for sleep or not sleeping for long periods of time without feeling tired).',
            '- Impulsive behavior or behavior you felt unable to control and caused negative consequences (e.g., uncontrolled gambling, other addictive behavior, compulsive sexual behavior etc.).',
            '- A plan to hurt or kill someone else that you either acted upon or would have acted upon if someone had not intervened.',
          ],
          appendLabel: 'Add another treatment',
          itemType: 'Treatment Item',
        },
      },
      diagnosis: {
        heading: {
          diagnosed: 'What are the treatment dates?',
          healthcareProfessional: 'Health care professional info',
          effective: 'Was the counseling/treatment effective in managing your symptoms?',
          facility: 'Agency/organization/facility',
          explanation: 'Provide explanation',
        },
        help: {
          diagnosed: {
            title: 'Provide the full date range (start to finish) of your counseling or treatment',
            message:
            'If you are not sure of the exact date range give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
        person: {
          heading: {
            name: 'What is the name of the health care professional who treated you in the last five years, or is currently treating you?',
            address: 'Provide the address of the health care professional',
          },
          label: {
            address: 'Is the address of the healthcare professional who treated you in the last five years, or is currently treating in the U.S.?',
            addressDomesticTitle: 'What is the address?',
            addressForeignTitle: 'What is the address?',
            name: 'Name',
            phone: 'What is the health care professional\'s telephone number?',
          },
          help: {
            address: {
              title: "Try looking up this health care professional's name",
              message:
              'A physical or mailing address should be associated with the name. If you can only find a phone number try calling and asking for the address.',
              note:
              'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
            },
            name: {
              title: 'Need help the name and number of this healthcare professional?',
              message:
              'Tell us the full name of the healthcare professional and a current phone number for them.',
              note: 'Note: If you can’t remember these a family member may be able to help you.',
            },
          },
          comments: 'Optional Comments',
        },
        facility: {
          heading: {
            name:
            'Provide the name and telephone number of any agency/organization/facility where counseling/treatment was provided',
            address:
            'Provide the address of any agency/organization/facility where counseling/treatment was provided',
          },
          label: {
            address: 'This address is',
            name: 'Name',
            phone: 'Telephone',
          },
          comments: 'Optional Comments',
          help: {
            address: {
              title:
              "Try looking up the treatment facility's name, this could help you find the address",
              message: 'If you can only find a phone number try calling and asking for the address.',
              note:
              'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
            },
            name: {
              title: 'Need help the facility where treatment was provided?',
              message: 'Tell us the name of the facility where your treatment was.',
              note: 'Note: If you can’t remember this name a family member may be able to help you.',
            },
          },
        },
        comments: 'Optional Diagnosis Comments',
      },
    },
  },
  heading: {
    intro: 'Why we are asking',
    competence:
      'Has a court or administrative agency ever issued an order declaring you mentally incompetent?',
    consultation:
      'Has a court or administrative agency EVER ordered you to consult with a mental health professional?',
    consultation2:
      'For example, a psychiatrist, psychologist, licensed clinical social worker, etc.\n\nAn order to a military member by a superior officer is not within the scope of this question, and therefore would not require an affirmative response.',
    hospitalization: 'Have you EVER been hospitalized for a mental health condition?',
    diagnoses:
      'The following question asks whether you have been diagnosed with a specified mental health condition that may, particularly if untreated, impact your judgment, reliability, or trustworthiness. If you answer in the affirmative, we will seek additional information about the seriousness and symptoms of the condition, as well as any applicable course of treatment.\n\nIt is important to note that any such diagnosis, in and of itself, **is not a reason** to revoke or deny eligibility/or access to classified information or for holding a sensitive position, suitability or fitness to obtain or retain Federal or contract employment, or eligibility for physical or logical access to federally controlled facilities or information systems.',
  },
  section: {
    name: 'Psychological and emotional health',
  },
  subsection: {
    intro: 'Introduction',
    competence: 'Competence',
    consultations: 'Consultations',
    hospitalizations: 'Hospitalizations',
    diagnoses: 'Diagnoses',
    conditions: 'Existing conditions',
    review: 'Review',
  },
  destination: {
    intro: 'Psychological and emotional health intro',
    psychological: 'Psychological and emotional health',
    competence: 'Competence',
    consultation: 'Consultations',
    consultations: 'Consultations',
    hospitalization: 'Hospitalizations',
    hospitalizations: 'Hospitalizations',
    diagnoses: 'Diagnoses',
    conditions: 'Existing conditions',
    existingConditions: 'Existing conditions',
    review: 'Review',
  },
  default: {
    label: {
      toDate: 'N/A',
      fromDate: 'N/A',
    },
  },
  appealsComments: 'Optional Comments',
  intro: {
    title: 'Psychological and emotional health',
    para1:
      'The U.S. government recognizes the critical importance of mental health and advocates proactive management of mental health conditions to support the wellness and recovery of Federal employees and others. Every day individuals with mental health conditions carry out their duties without presenting a security risk. While most individuals with mental health conditions do not present security risks, there may be times when such a condition can affect a person’s eligibility for a security clearance.',
    para2:
      'Individuals experience a range of reactions to traumatic events. For example, the death of a loved one, divorce, major injury, service in a military combat environment, sexual assault, domestic violence, or other difficult work-related, family, personal, or medical issues may lead to grief, depression, or other responses. The government recognizes that mental health counseling and treatment may provide important support for those who have experienced such events, as well as for those with other mental health conditions. Nothing in this questionnaire is intended to discourage those who might benefit from such treatment from seeking it.',
    para3:
      '**Mental health treatment and counseling, in and of itself, is not a reason to revoke or deny eligibility** for access to classified information or for holding a sensitive position, suitability or fitness to obtain or retain Federal or contract employment, or eligibility for physical or logical access to federally controlled facilities or information systems.',
    para4:
      '**Seeking or receiving mental health care for personal wellness and recovery may contribute favorably to decisions about your eligibility.**',
  },
  tour: {
    para: 'Take a guided tour through the section',
  },
  review: {
    para: 'View all the sections associated with psychological and emotional health at once',
  },
  competence: {
    heading: {
      occurred: 'Provide the date this occurred',
      courtName:
        'Provide the name of the court or administrative agency that declared you mentally incompetent',
      courtAddress: 'Provide the address of the court or administrative agency',
      disposition: 'Provide the final disposition',
      appealCourtName: 'Provide the name of the higher court or administrative agency',
      appealCourtAddress: 'Provide the address of the court or administrative agency',
      appealed: 'Was this matter appealed to a higher court or administrative agency?',
      appealedAnother:
        'Do you have an additional instance where this matter was appealed to a higher court or administrative agency?',
      needMore: 'Since you answered yes, we need more information',
    },
    label: {
      courtAddress: 'This address is',
      disposition: 'Provide the final disposition',
    },
    help: {
      occurred: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      courtName: {
        title: 'Need help with this court or agency name?',
        message: 'Tell us the name of the court or administrative agency that issued the order.',
        note: '',
      },
      courtAddress: {
        title: 'Try looking up the court or agency name, this could help you find the address',
        message: 'If you can only find a phone number try calling and asking for the address.',
        note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
      },
      incompetent: {
        title: 'Need help with this question?',
        message:
          'Has a court or administrative agency EVER ordered you to consult with a mental health professional?',
      },
      disposition: {
        title: "Tell us the ruling regarding the court or agency's decision",
        message:
          "If you can't remember your disposition a family member or the court/agency may be able to help you.",
        note: '',
      },
    },
    collection: {
      summaryCourtName: 'Provide your order details below',
      description: 'Summary of orders',
      appendTitle:
        'Do you have an additional instance where a court or administrative agency EVER issued an order declaring you mentally incompetent?',
      appendLabel: 'Add another order',
      itemType: 'Order Item',
    },
    comments: 'Optional Comments',
    summaryComments: 'Optional Summary Comments',
  },
  consultation: {
    heading: {
      occurred: 'Provide the date this occurred',
      courtName:
        'Provide the name of the court or administrative agency that ordered you to consult with a mental health professional',
      courtAddress: 'Provide the address of the court or administrative agency',
      disposition: 'Provide the final disposition',
      appealCourtName: 'Name of court or administrative agency',
      appealCourtAddress: 'Provide the address of the court or administrative agency',
      appealed: 'Was this matter appealed to a higher court or administrative agency?',
      appealedAnother:
        'Do you have an additional instance where this matter was appealed to a higher court or administrative agency?',
      needMore: 'Since you answered yes, we need more information',
    },
    label: {
      courtAddress: 'This address is',
      disposition: 'Provide the final disposition',
    },
    help: {
      occurred: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      courtName: {
        title: 'Need help with this court or agency name?',
        message: 'Tell us the name of the court or administrative agency that issued the order.',
        note: '',
      },
      courtAddress: {
        title: 'Try looking up the court or agency name, this could help you find the address',
        message: 'If you can only find a phone number try calling and asking for the address.',
        note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
      },
      disposition: {
        title: "Tell us the ruling regarding the court or agency's decision",
        message:
          "If you can't remember your disposition a family member or the court/agency may be able to help you.",
        note: '',
      },
      appealed: {
        title: 'Need help with whether this matter was appealed?',
        message: 'Was this matter appealed to a higher court or administrative agency?',
        note: '',
      },
      incompetent: {
        title: 'Need help with this question?',
        message:
          'Has a court or administrative agency EVER ordered you to consult with a mental health professional',
      },
    },
    collection: {
      summaryCourtName: 'Provide your order details below',
      description: 'Summary of orders',
      appendTitle:
        'Do you have an additional instance where a court or administrative agency EVER issued an order declaring you mentally incompetent?',
      appendLabel: 'Add another order',
      itemType: 'Order Item',
    },
    comments: 'Optional Comments',
    summaryComments: 'Optional Summary Comments',
  },
  hospitalization: {
    heading: {
      admission: 'Was the admission voluntary or involuntary?',
      treatment: 'Provide the dates of treatment',
      facility: 'Provide the name of the facility where treatment was provided',
      address: 'Provide the address of the facility where treatment was provided',
      explanation: 'Provide explanation',
    },
    label: {
      address: 'This address is',
      voluntaryAdmission: 'Voluntary',
      involuntaryAdmission: 'Involuntary',
    },
    collection: {
      description: 'Summary of hospitalizations',
      summary: 'Provide your hospitalization details below',
      appendTitle:
        'Do you have an additional instance where you have EVER been hospitalized for a mental health condition?',
      appendLabel: 'Add another hospitalization',
      itemType: 'Hospitalization Item',
    },
    help: {
      incompetent: {
        title: 'Need help with mental health hospitalization?',
        message: 'Have you EVER been hospitalized for a mental health condition?',
        note: '',
      },
      treatment: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      facility: {
        title: 'Need help with this facility name?',
        message: 'Tell us the name of the facility where you were hospitalized.',
        note: '',
      },
      address: {
        title: 'Try looking up the facility name, this could help you find the address',
        message: 'If you can only find a phone number try calling and asking for the address.',
        note:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
      },
    },
    comments: 'Optional Comments',
    itemComments: 'Optional Comments',
    summaryComments: 'Optional Summary Comments',
  },
  diagnosis: {
    heading: {
      condition: 'Identify the diagnosis or health condition',
      diagnosed: 'Provide the dates of diagnosis',
      healthcareProfessional: 'Health care professional info',
      effective: 'Was the counseling/treatment effective in managing your symptoms?',
      facility: 'Agency/organization/facility',
      explanation: 'Provide explanation',
    },
    label: {
      psychotic: 'Psychotic disorder',
      schizophrenia: 'Schizophrenia',
      schizoaffective: 'Schizoaffective disorder',
      delusional: 'Delusional disorder',
      bipolar: 'Bipolar mood disorder',
      borderline: 'Borderline personality disorder',
      antisocial: 'Antisocial personality disorder',
    },
    help: {
      condition: {
        title: 'Need help with health condition',
        message: 'Provide the name of the diagnosis or health condition',
        note: '',
      },
      diagnosed: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note:
          'Note: If this is a current diagnosis or health condition enter the start date and click the "Present" button for the "To date".',
      },
      explanation: {
        title: "Tell us more about why the counseling/treatment wasn't effective?",
        message: "Let us know why this counseling/treatment didn't improve your symptoms.",
        note: 'Go into as much detail as you need to full explain.',
      },
    },
    comments: 'Optional Comments',
    person: {
      heading: {
        name:
          'Provide the name and telephone number of the health care professional who diagnosed you, or is currently treating you for such diagnosis, or with whom you have discussed such condition',
        address:
          'Provide the address of the health care professional who diagnosed you, or is currently treating you for such diagnosis, or with whom you have discussed such condition',
      },
      label: {
        address: 'This address is',
        name: 'Name',
        phone: 'Telephone',
      },
      help: {
        address: {
          title: 'Try looking up their name, this could help you find the address',
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        name: {
          title: 'Need help the name of the healthcare professional?',
          message: 'Tell us the full name of the healthcare professional.',
          note: 'Note: If you can’t remember this name a family member may be able to help you.',
        },
      },
      comments: 'Optional Comments',
    },
    facility: {
      heading: {
        name:
          'Provide the name and telephone number of any agency/organization/facility where counseling/treatment was provided',
        address:
          'Provide the address of any agency/organization/facility where counseling/treatment was provided',
      },
      label: {
        name: 'Name',
        phone: 'Telephone',
        address: 'This address is',
      },
      help: {
        address: {
          title: 'Try looking up the name, this could help you find the address.',
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        name: {
          title: 'Need help entering name of the facility where treatment was provided?',
          message: 'Tell us the full name of the facility.',
          note:
            'Note: If you can’t remember this facility name a family member may be able to help you.',
        },
      },
      comments: 'Optional Comments',
    },
  },
  diagnoses: {
    heading: {
      didNotConsult:
        'In the last seven years, have there been any occasions when you did not consult with a medical professional before altering or discontinuing, or failing to start a prescribed course of treatment for any of the listed diagnoses?',
      diagnoses:
        'Have you EVER been diagnosed by a physician or other health professional with psychotic disorder, schizophrenia, schizoaffective disorder, delusional disorder, bipolar mood disorder, borderline personality disorder, or antisocial personality disorder?',
      examples:
        'Health professional examples: a psychiatrist, psychologist, licensed clinical social worker, or nurse practitioner.',
      inTreatment: 'Are you currently in treatment?',
    },
    collection: {
      description: 'Summary of diagnoses',
      summary: 'Provide your diagnosis details below',
      appendTitle:
        'Do you have an additional instance where you EVER had been diagnosed by a physician or other health professional (for example, a psychiatrist, psychologist, licensed clinical social worker, or nurse practitioner) with psychotic disorder, schizophrenia, schizoaffective disorder, delusional disorder, bipolar mood disorder, borderline personality disorder, or antisocial personality disorder?',
      appendMessage:
        'Health professional examples: a psychiatrist, psychologist, licensed clinical social worker, or nurse practitioner.',
      appendLabel: 'Add another diagnosis',
      itemType: 'Diagnosis Item',
    },
    professional: {
      heading: {
        name:
          'Provide the name and telephone number of the health care professional who diagnosed you, or is currently treating you for such diagnosis, or with whom you have discussed such condition',
        address:
          'Provide the address of the health care professional who diagnosed you, or is currently treating you for such diagnosis, or with whom you have discussed such condition',
      },
      label: {
        address: 'This address is',
        name: 'Name',
        phone: 'Telephone',
      },
      help: {
        name: {
          title: 'Need help the name of the healthcare professional?',
          message: 'Tell us the full name of the healthcare professional.',
          note: 'Note: If you can’t remember this name a family member may be able to help you.',
        },
        address: {
          title: 'Try looking up their name, this could help you find the address',
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
      },
      comments: 'Optional Comments',
    },
    treatment: {
      collection: {
        description: 'Summary of treatments',
        summary: 'Provide your treatment details below',
        appendTitle: 'Do you have an additional instance where you are currently in treatment?',
        appendLabel: 'Add another treatment',
        itemType: 'Treatment Item',
      },
    },
    inTreatmentSummaryComments: 'Optional Summary Comments',
    didNotConsultComments: 'Optional Comments',
    summaryComments: 'Optional Summary Comments',
    comments: 'Optional Comments',
    inTreatmentComments: 'Optional Comments',
    help: {
      diagnosed: {
        title: 'Help with diagnoses',
        message:
          'Have you EVER been diagnosed by a physician or other health professional (for example, a psychiatrist, psychologist, licensed clinical social worker, or nurse practitioner) with psychotic disorder, schizophrenia, schizoaffective disorder, delusional disorder, bipolar mood disorder, borderline personality disorder, or antisocial personality disorder?',
        note: '',
      },
      didNotConsult: {
        title: 'Help with occasions when not consulting',
        message:
          'In the last seven years, have there been any occasions when you did not consult with a medical professional before altering or discontinuing, or failing to start a prescribed course of treatment for any of the listed diagnoses?',
        note: '',
      },
      inTreatment: {
        title: 'Help with current treatment',
        message: 'Are you currently in treatment?',
        note: '',
      },
      condition: {
        title: 'Help with diagnosis',
        message: 'Identify the diagnosis or health condition',
        note: '',
      },
    },
    person: {
      help: {
        name: {
          title: 'Need help the name of the healthcare professional?',
          message: 'Tell us the full name of the healthcare professional.',
        },
        address: {
          title:
            "Try looking up the health care professional's name, this could help you find the address",
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
      },
    },
  },
  existingConditions: {
    heading: {
      hasCondition:
        'Do you have a mental health or other health condition that substantially adversely affects your judgment, reliability, or trustworthiness even if you are not experiencing such symptoms today?',
      receivedTreatment:
        'Did you ever receive or are you currently receiving counseling or treatment for that condition?',
      didNotFollow:
        'Have you ever chosen not to follow a prescribed course of treatment for any of these conditions?',
      explanation: 'Provide explanation',
      didNotFollowExplanation: 'Provide explanation',
    },
    para: {
      hasCondition:
        'Note: If your judgment, reliability, or trustworthiness is not substantially adversely affected by a mental health or other condition, then you should answer **"no"** even if you have a mental health or other condition requiring treatment.\n\nFor example, if you are in need of emotional or mental health counseling as a result of service as a first responder, service in a military combat environment, having been sexually assaulted or a victim of domestic violence, or marital issues, but your judgment, reliability or trustworthiness is not substantially adversely affected, then answer **"no."**',
      receivedTreatment:
        'You may choose not to answer this question. However, such consultation or treatment will not disqualify you and is considered to be a positive action.',
    },
    help: {
      receivedTreatment: {
        title: 'Help with counseling or treatment',
        message:
          'Did you ever receive or are you currently receiving counseling or treatment for that condition?',
        note: '',
      },
      didNotFollow: {
        title: 'Help with following prescribed course of treatment',
        message:
          'Have you ever chosen not to follow a prescribed course of treatment for any of these conditions?',
        note: '',
      },
      didNotFollowExplanation: {
        title: 'Help with not following prescribed course of action explanation',
        message: 'Provide explanation',
        note: '',
      },
    },
    comments: 'Optional Comments',
    receivedTreatmentComments: 'Optional Comments',
    didNotReceiveTreatmentComments: 'Optional Comments',
    receivedTreatmentSummaryComments: 'Optional Summary Comments',
    didNotFollowComments: 'Optional Comments',
    explanationComments: 'Optional Comments',
    receivedTreatment: {
      label: {
        yes: 'Yes',
        no: 'No',
        decline: 'I decline to answer',
      },
    },
    treatment: {
      collection: {
        description: 'Summary of treatments',
        summary: 'Provide your treatment details below',
        appendTitle:
          'Do you have an additional instance where you ever received are you currently receiving counseling or treatment for that condition',
        appendLabel: 'Add another treatment',
        itemType: 'Treatment Item',
      },
    },
    diagnosis: {
      heading: {
        diagnosed: 'Provide the dates of counseling or treatment',
        healthcareProfessional: 'Health care professional info',
        effective: 'Was the counseling/treatment effective in managing your symptoms?',
        facility: 'Agency/organization/facility',
        explanation: 'Provide explanation',
      },
      help: {
        diagnosed: {
          title: 'Provide the full date range (start to finish) of your counseling or treatment',
          message:
            'If you are not sure of the exact date range give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
      },
      person: {
        heading: {
          name: 'Provide the name and telephone number of the health care professional',
          address: 'Provide the address of the health care professional',
        },
        label: {
          address: 'This address is',
          name: 'Name',
          phone: 'Telephone',
        },
        help: {
          address: {
            title: "Try looking up this health care professional's name",
            message:
              'A physical or mailing address should be associated with the name. If you can only find a phone number try calling and asking for the address.',
            note:
              'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
          name: {
            title: 'Need help the name and number of this healthcare professional?',
            message:
              'Tell us the full name of the healthcare professional and a current phone number for them.',
            note: 'Note: If you can’t remember these a family member may be able to help you.',
          },
        },
        comments: 'Optional Comments',
      },
      facility: {
        heading: {
          name:
            'Provide the name and telephone number of any agency/organization/facility where counseling/treatment was provided',
          address:
            'Provide the address of any agency/organization/facility where counseling/treatment was provided',
        },
        label: {
          address: 'This address is',
          name: 'Name',
          phone: 'Telephone',
        },
        comments: 'Optional Comments',
        help: {
          address: {
            title:
              "Try looking up the treatment facility's name, this could help you find the address",
            message: 'If you can only find a phone number try calling and asking for the address.',
            note:
              'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
          name: {
            title: 'Need help the facility where treatment was provided?',
            message: 'Tell us the name of the facility where your treatment was.',
            note: 'Note: If you can’t remember this name a family member may be able to help you.',
          },
        },
      },
      comments: 'Optional Diagnosis Comments',
    },
  },
};
